const SELECTOR_FORM = '.js-blog-pages-filter-form';
const SELECTOR_CLEAN = '.js-blog-pages-filter-clean';

export function initBlogPagesFilter(): void {
  const forms = document.querySelectorAll<HTMLFormElement>(SELECTOR_FORM);

  for (const form of forms) {
    const cleanButton = form.querySelector<HTMLButtonElement>(SELECTOR_CLEAN);

    if (cleanButton === null) {
      continue;
    }

    cleanButton.addEventListener('click', () => {
      const checkboxes = form.querySelectorAll<HTMLInputElement>(
        'input[type="checkbox"]',
      );

      for (const checkbox of checkboxes) {
        checkbox.checked = false;
      }
    });
  }
}
